class NumberUp extends HTMLElement {
  constructor() {
    super();
    this.shadow = this.attachShadow({ mode: 'open' });
    this.numberSpan = document.createElement('span');
    this.shadow.appendChild(this.numberSpan);
    this.targetNumber = 0;
    this.currentNumber = 0;
    this.intervalId = null;
    this.hasAnimated = false;
  }

  connectedCallback() {
    this.targetNumber = parseInt(this.textContent.trim(), 10);
    if (isNaN(this.targetNumber)) {
      this.targetNumber = 0;
    }
    this.numberSpan.textContent = this.targetNumber.toString();
    requestAnimationFrame(() => {
      const computedWidth = this.numberSpan.offsetWidth;
      this.numberSpan.style.width = `${computedWidth}px`;
      this.numberSpan.textContent = '0';
    });
    this.observer = new IntersectionObserver(this._handleIntersection.bind(this), {
      root: null,
      rootMargin: '0px',
      threshold: 0.5
    });
    this.observer.observe(this);
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  _handleIntersection(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting && !this.hasAnimated) {
        this.hasAnimated = true;
        this.observer.unobserve(this);
        this._startCounting();
      }
    });
  }

  _startCounting() {
    const duration = 1000;
    const framesPerSecond = 60;
    const totalFrames = (duration / 1000) * framesPerSecond;
    const increment = this.targetNumber / totalFrames;
    let counter = 0;

    this.intervalId = setInterval(() => {
      counter += increment;
      if (counter >= this.targetNumber) {
        this.numberSpan.textContent = this.targetNumber;
        clearInterval(this.intervalId);
      } else {
        this.numberSpan.textContent = Math.round(counter);
      }
    }, 1000 / framesPerSecond);
  }
}
if (!customElements.get('number-up')) {
  customElements.define('number-up', NumberUp);
}
